import {
  IRequirementResponse,
  PayeeTaxDocumentSharePermission
} from "@wingspanhq/payments/dist/interfaces";
import { useModalShareTaxInformationWithPayers } from "../../../../../../shared/components/ModalShareTaxInformationWithPayers/useModalShareTaxInformationWithPayers";
import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementAction,
  RequirementTableCallback
} from "../../../../types";
import { TaxVerificationAdditionalData } from "../../types";
import { getTaxVerificationRequirementName } from "../helpers/getTaxVerificationRequirementName";
import { getTaxVerificationRequirementPayerStatusCell } from "../helpers/getTaxVerificationRequirementPayerStatusCell";

export const usePayerTaxVerificationConfig = (
  _: RequirementTableCallback
): CellsConfig<
  IRequirementResponse,
  ContextItem,
  TaxVerificationAdditionalData
> => {
  const modalFormW9Consent = useModalShareTaxInformationWithPayers();

  return {
    isActionRequired: () => false,

    requirementName: getTaxVerificationRequirementName,

    nameCell: requirement => ({
      text: getTaxVerificationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.requirementType
      }),

    statusCell: getTaxVerificationRequirementPayerStatusCell,

    toolbarActions: (requirement, context, dataSource) => {
      const actions: RequirementAction[] = [];

      const taxDocumentSharePermission = requirement.dataSourceMetadata
        ?.payeeOwnedData?.shareTaxDocument as
        | PayeeTaxDocumentSharePermission
        | undefined;

      if (
        context.hideTaxVerificationConsent !== true &&
        taxDocumentSharePermission !== PayeeTaxDocumentSharePermission.Allow
      ) {
        actions.push({
          label: "Consent to share information",
          icon: "clipboard-check",
          onClick: () => {
            modalFormW9Consent.open({
              payerId: requirement.payerId
            });
          }
        });
      }

      return actions;
    }
  };
};
